/* eslint-disable react/prop-types */
import React from "react";
import "./Navigation.css";
import Button from "@mui/material/Button";
import useRecognizeConnect from "../../providers/RecognizeConnect/RecognizeConnect";
import { inputFocusCursor } from "../../providers/RecognizeConnect/recognize_connect_common";
import { copyToClipboard } from "../../speech_recognition/clipboard_common";

const NavBasic = () => {
  const { editTextRef } = useRecognizeConnect();

  const copyRecordingClickHandle = () => {
    if (editTextRef !== null && editTextRef.current !== null) {
      copyToClipboard(editTextRef.current.value);
    }
  };

  const newRecordingClickHandle = () => {
    if (editTextRef !== null && editTextRef.current !== null) {
      editTextRef.current.value = "";
      inputFocusCursor(editTextRef);
    }
    // setRecognitionText("");
  };

  return (
    <div
      className="navigation-main-group"
      style={{ flexDirection: "column", marginTop: 0 }}
    >
      <div
        className="navigation-main-group"
        style={{ justifyContent: "space-between", marginTop: "0rem" }}
      >
        <Button variant="contained" onClick={copyRecordingClickHandle}>
          COPY
        </Button>
        <Button
          variant="contained"
          onClick={newRecordingClickHandle}
          sx={{ marginLeft: "1rem" }}
        >
          CLEAR
        </Button>
      </div>
    </div>
  );
};

export default NavBasic;
